
import {rawDataApi} from "@/axios";

// 查询项目共享人列表
export function listProjectSharerRaw(projectId) {
    return rawDataApi({
        url: '/raw/project/share/list/'+projectId,
        method: 'get',
    })
}
// 删除项目共享人
export function delProjectSharerRaw(data) {
    return rawDataApi({
        url: '/raw/project/share/delete',
        method: 'post',
        data:data
    })
}
export function addProjectSharerRaw(data){
    return rawDataApi({
        url:'/raw/project/share/add',
        method:'post',
        data:data
    })
}
export function getReportLink(id){
    return rawDataApi({
        url: '/raw/project/download-url/'+id,
        method: 'get',
    })
}
